import { QUERY_STATE } from '@tmapy/utils';
import { NOTES_SET_STATE, NOTES_SAVE_START, NOTES_SAVE_SUCCESS, NOTES_SAVE_FAILURE, } from '../constants';
import { getInitialState } from './initialState';
export const notes = (state = getInitialState(), action) => {
    switch (action.type) {
        case NOTES_SAVE_START: {
            return {
                ...state,
                saveQueryState: QUERY_STATE.WAITING,
            };
        }
        case NOTES_SAVE_SUCCESS: {
            return {
                ...state,
                saveQueryState: QUERY_STATE.SUCCESS,
                isChanged: false,
            };
        }
        case NOTES_SAVE_FAILURE: {
            return {
                ...state,
                saveQueryState: QUERY_STATE.FAIL,
            };
        }
        case NOTES_SET_STATE: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map